module.exports = __webpack_public_path__ + "last-stay-nights.png?9ffa89af86660209c9486827f0e13d18";